import React, { useEffect } from 'react';
import { useAnalytics } from '../context/AnalyticsContext';
import { useAuth } from '../context/AuthContext';
import usePageTracking from '../hooks/usePageTracking';

/**
 * Analytics sistemini başlatan component
 * Sayfa yüklendiğinde analytics'i initialize eder ve sayfa takibini başlatır
 */
const AnalyticsInitializer = () => {
  const { initializeAnalytics, isInitialized } = useAnalytics();
  const { user } = useAuth();

  // Sayfa takibini başlat
  usePageTracking();

  // Analytics'i initialize et
  useEffect(() => {
    if (!isInitialized) {
      initializeAnalytics(user?.id || null);
    }
  }, [initializeAnalytics, isInitialized, user?.id]);

  // Kullanıcı giriş/çıkış durumunda analytics'i güncelle
  useEffect(() => {
    if (isInitialized) {
      // Kullanıcı durumu değiştiğinde session'ı güncelle
      initializeAnalytics(user?.id || null);
    }
  }, [user?.id, isInitialized, initializeAnalytics]);

  // Bu component görünmez, sadece initialization için
  return null;
};

export default AnalyticsInitializer;
